/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest
 */
export interface JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest
     */
    userAgent?: string;
}

export function JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequestFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest {
    return JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequestFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userAgent': !exists(json, 'userAgent') ? undefined : json['userAgent'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequestToJSON(value?: JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userAgent': value.userAgent,
    };
}

